import React from 'react'

import { compareStringWithAccent } from 'utils/string'
import PartnerOfferCard from 'components/Card/PartnerOffer'
import MailIcon from 'components/Icons/MailIcon'
import PhoneIcon from 'components/Icons/PhoneIcon'
import WhatsappIcon from 'components/Icons/WhatsappIcon'
import ExternalLinkIcon from 'components/Icons/ExternalLinkIcon'

const CTA_TYPE = {
  Phone: {
    icon: PhoneIcon,
    resolver: (phone) => window.open(`tel:${phone}`, '_blank')
  },
  Email: {
    icon: MailIcon,
    resolver: (mail) => window.open(`mailto:${mail}`, '_blank')
  },
  WhatsApp:  {
    icon: WhatsappIcon,
    resolver: (whatsNumber) => window.open(`https://wa.me/${whatsNumber}`, '_blank')
  },
  'Book Url': {
    icon: ExternalLinkIcon,
    resolver: (bookUrl) => window.open(bookUrl, '_blank')
  }
}

const getCtaBySelectedVillage = (ctaList, currentVillage) => {
  if(!ctaList?.length) return { ctaType: 'Book Url', ctaValue: 'https://thebicestercollection.com' }

  if(!currentVillage) {
    return ctaList[0]
  }

  
  return ctaList?.find(({ village }) => compareStringWithAccent(village, currentVillage)) ?? {}
}

const mapServiceCard = (service, bookLabel, currentVillage, fullSize = false) => {
  const { ctaType, ctaValue } = getCtaBySelectedVillage(service.serviceCtaList, currentVillage) 

  const Icon = CTA_TYPE[ctaType]?.icon
  const onPress = CTA_TYPE[ctaType]?.resolver
  
  return (
    <PartnerOfferCard
      key={service.id}
      title={service.title}
      content={service.description}
      image={service.image}
      hideAction={!ctaType}
      actionLabel={
        <>
          {bookLabel ?? 'How to book'}
          <Icon width="16px" height="16px" viewBox="0 0 32 32" />
        </>
      }
      onActionPress={() => onPress(ctaValue)}
      fullSize={fullSize}
    />
  )
}

export default mapServiceCard